// extracted by mini-css-extract-plugin
export default {"PageStart":"DefectList_PageStart__k5mar","Card":"DefectList_Card__ygFZ3","CustomPageBar":"DefectList_CustomPageBar__Rp9ak"};